<template>
  <el-select
    v-model="modelVal"
    clearable
    filterable
    :remote="isRemote"
    :remote-method="isRemote ? debouncedBuscar : undefined"
    :filter-method="!isRemote ? filtrarLocal : undefined"
    :loading="carregando"
    no-match-text="Nenhum resultado encontrado"
    no-data-text="Nenhum dado disponível"
    placeholder="Selecionar..."
    style="width: 100%"
    @visible-change="onAbrirDropdown"
  >
    <el-option
      v-for="item in opcoesFiltradas"
      :key="item._id"
      :label="String(item._id)"
      :value="item._id"
    >
      <span>{{ item._id }} - {{ item._name }}</span>
    </el-option>
  </el-select>
</template>

<script>
import ncformCommon from '@ncform/ncform-common';
import { get } from '@/helpers/apiRequest';

export default {
  name: 'SearchSelectWidget',
  mixins: [ncformCommon.mixins.vue.controlMixin],

  data() {
    return {
      opcoes: [],
      carregando: false,
      filtro: '',
      timer: null,
    };
  },

  computed: {
    isRemote() {
      return this.mergeConfig.preload === false;
    },
    opcoesFiltradas() {
      if (!this.filtro || this.isRemote) return this.opcoes;
      const q = this.filtro.toLowerCase();
      return this.opcoes.filter(i =>
        `${i._id} - ${i._name}`.toLowerCase().includes(q)
      );
    },
  },

  methods: {
    filtrarLocal(q) {
      this.filtro = q;
    },
    debouncedBuscar(q) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this._fetchOpcoes(q), 300);
    },
    onAbrirDropdown(visible) {
      if (!visible) return;
      if (!this.isRemote) this.filtro = '';
      if (this.isRemote && this.opcoes.length === 0) this._fetchOpcoes('');
    },
    async _fetchOpcoes(query) {
      const cfg = this.mergeConfig;
      if (!cfg.searchUrl) return;
      const idField = cfg.idField || 'id';
      const labelField = cfg.labelField || 'descricao';
      const labelFields = cfg.labelFields;
      const take = !this.isRemote ? 500 : 50;
      this.carregando = true;
      try {
        const qs = query ? `&q=${encodeURIComponent(query)}` : '';
        const data = await get(`${cfg.searchUrl}?take=${take}${qs}`);
        const itens = data.itens || data.data || (Array.isArray(data) ? data : []);
        this.opcoes = itens.map(item => ({
          ...item,
          _id: item[idField],
          _name: labelFields && labelFields.length
            ? labelFields.map(f => item[f]).filter(Boolean).join(' / ')
            : item[labelField] || '',
        }));
      } catch {
        this.opcoes = [];
      } finally {
        this.carregando = false;
      }
    },
  },

  mounted() {
    if (!this.isRemote && this.mergeConfig.searchUrl) {
      this._fetchOpcoes('');
    }
  },
};
</script>
